export default __webpack_public_path__ + "static/media/p1-5.346415c1.png";